import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32651323"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-size max-w-screen-lg box-border select-none" }
const _hoisted_2 = { class: "flex w-full h-full" }
const _hoisted_3 = {
  class: "bg-primary-500 dark:bg-primary-600 px-10 py-10 flex justify-center items-center",
  style: {"width":"30%"}
}
const _hoisted_4 = { class: "text-3xl font-bold text-white" }
const _hoisted_5 = { class: "text-lg font-bold text-white mt-10" }
const _hoisted_6 = {
  class: "underline text-lg font-bold text-white hover:text-gray-300",
  href: "https://onlinejudge.u-aizu.ac.jp/term_of_use",
  target: "_blank"
}
const _hoisted_7 = { class: "mr-5" }
const _hoisted_8 = { class: "mb-10 text-2xl font-bold" }
const _hoisted_9 = { class: "flex mt-4" }
const _hoisted_10 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_12 = { class: "text-gray-400 dark:text-dark-text-dark text-sm mt-1" }
const _hoisted_13 = { class: "flex mt-6" }
const _hoisted_14 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_16 = { class: "text-gray-400 dark:text-dark-text-dark text-sm mt-1" }
const _hoisted_17 = { class: "flex mt-4" }
const _hoisted_18 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_20 = { class: "flex mt-6" }
const _hoisted_21 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_23 = { class: "text-gray-400 dark:text-dark-text-dark text-sm mt-1" }
const _hoisted_24 = { class: "mt-6 text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_25 = { class: "text-gray-400 dark:text-dark-text-dark text-sm mt-1" }
const _hoisted_26 = { class: "mt-6 text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "relative mt-2" }
const _hoisted_29 = {
  class: "cursor-pointer shadow-lg px-6 bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-700 dark:bg-primary-600 dark:hover:bg-primary-700 dark:active:bg-primary-800",
  for: "avatar-input",
  style: {"border-radius":"0.5rem","transition":"background 0.25s","font-weight":"700","padding-top":"11px","padding-bottom":"11px"}
}
const _hoisted_30 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "flex mt-6" }
const _hoisted_33 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_35 = { class: "flex mt-6" }
const _hoisted_36 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_38 = { class: "flex mt-6" }
const _hoisted_39 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_41 = { class: "text-gray-400 dark:text-dark-text-dark text-sm mt-1" }
const _hoisted_42 = { class: "flex mt-6" }
const _hoisted_43 = { class: "text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 mb-1 ml-1" }, "*", -1))
const _hoisted_45 = { class: "text-gray-400 dark:text-dark-text-dark text-sm mt-1" }
const _hoisted_46 = { class: "mt-6 text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_47 = { class: "mt-6 text-gray-500 dark:text-dark-text-dark mb-1" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-gray-500 dark:text-dark-text-dark mb-1" }, "URL", -1))
const _hoisted_49 = { class: "text-gray-400 dark:text-dark-text-dark text-sm mt-1" }
const _hoisted_50 = { class: "flex justify-center mt-8" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"36px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleLineInputArea = _resolveComponent("SingleLineInputArea")!
  const _component_IconTextButton = _resolveComponent("IconTextButton")!
  const _component_CountryDropDown = _resolveComponent("CountryDropDown")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_ScrollableDropDown = _resolveComponent("ScrollableDropDown")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, {
    onClickBackground: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('message.beforeSingup')), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('message.readTerms')), 1),
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('message.termOfUse')), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["overflow-y-scroll overflow-x-hidden pt-8 mx-2 my-5 flex justify-center", _ctx.isLightMode() ? 'custom-scrollbar' : 'custom-scrollbar-dark']),
            style: {"width":"70%"}
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('message.signup')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('message.accountId')), 1),
                _hoisted_11
              ]),
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setId,
                radius: '0.5rem',
                value: _ctx.userRegistrationStatePresenter.id.value
              }, null, 8, ["onChange", "value"]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('message.AlphabetsDigitsSymbols')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('message.password')), 1),
                _hoisted_15
              ]),
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setPassword,
                radius: '0.5rem',
                type: 'password',
                value: _ctx.userRegistrationStatePresenter.password.value
              }, null, 8, ["onChange", "value"]),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('message.moreThan4')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('message.confirmPassword')), 1),
                _hoisted_19
              ]),
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setConfirmPassword,
                radius: '0.5rem',
                type: 'password',
                value: _ctx.userRegistrationStatePresenter.confirmPassword.value
              }, null, 8, ["onChange", "value"]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('message.name')), 1),
                _hoisted_22
              ]),
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setName,
                radius: '0.5rem',
                value: _ctx.userRegistrationStatePresenter.name.value
              }, null, 8, ["onChange", "value"]),
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('message.AlphabetsDigitsSymbolsSpace')), 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('message.affiliation')), 1),
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setAffiliation,
                radius: '0.5rem',
                value: 
                _ctx.userRegistrationStatePresenter.affiliation.value == null
                  ? ''
                  : _ctx.userRegistrationStatePresenter.affiliation.value
              
              }, null, 8, ["onChange", "value"]),
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('message.AlphabetsDigitsSymbolsSpace')), 1),
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('message.avatar')), 1),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("input", {
                    id: "avatar-input",
                    accept: "image/*",
                    class: "hidden",
                    type: "file",
                    onChange: _cache[0] || (_cache[0] = event => _ctx.userRegistrationStatePresenter.uploadAvatar(event as InputEvent))
                  }, null, 32),
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('message.selectImage')), 1)
                ]),
                _createVNode(_component_IconTextButton, {
                  border_radius: 0.5,
                  class: "mx-2",
                  font_weight: '700',
                  icon: 'delete',
                  iconSize: 'text-xl',
                  padding_bottom: 4,
                  padding_left: 10,
                  padding_right: 10,
                  padding_top: 4,
                  text: _ctx.$t('message.delete'),
                  textSize: 'text-base',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.userRegistrationStatePresenter.setAvatar(null)))
                }, null, 8, ["text"])
              ]),
              (_ctx.userRegistrationStatePresenter.avatar.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("img", {
                      src: _ctx.userRegistrationStatePresenter.avatar.value,
                      style: {"max-width":"200px","max-height":"200px"}
                    }, null, 8, _hoisted_31)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('message.country')), 1),
                _hoisted_34
              ]),
              _createVNode(_component_CountryDropDown, {
                itemList: _ctx.userRegistrationStatePresenter.countryList,
                selected: _ctx.userRegistrationStatePresenter.setCountryIndex,
                selectedIndex: _ctx.userRegistrationStatePresenter.countryIndex.value
              }, null, 8, ["itemList", "selected", "selectedIndex"]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('message.displayLanguage')), 1),
                _hoisted_37
              ]),
              _createVNode(_component_DropDown, {
                itemList: _ctx.userRegistrationStatePresenter.displayLanguageList,
                selected: _ctx.userRegistrationStatePresenter.setDisplayLanguageIndex,
                selectedIndex: _ctx.userRegistrationStatePresenter.displayLanguageIndex.value
              }, null, 8, ["itemList", "selected", "selectedIndex"]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('message.programmingLanguage')), 1),
                _hoisted_40
              ]),
              _createVNode(_component_ScrollableDropDown, {
                itemList: _ctx.userRegistrationStatePresenter.programmingLanguageList,
                selected: _ctx.userRegistrationStatePresenter.setDefaultProgrammingLanguageIndex,
                selectedIndex: _ctx.userRegistrationStatePresenter.defaultProgrammingLanguageIndex.value
              }, null, 8, ["itemList", "selected", "selectedIndex"]),
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('message.defaultLanguageSettings')), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('message.sourceCodePolicy')), 1),
                _hoisted_44
              ]),
              _createVNode(_component_DropDown, {
                itemList: _ctx.userRegistrationStatePresenter.policyList,
                selected: _ctx.userRegistrationStatePresenter.setPolicyIndex,
                selectedIndex: _ctx.userRegistrationStatePresenter.policyIndex.value
              }, null, 8, ["itemList", "selected", "selectedIndex"]),
              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('message.sourceCodePolicyDescription')), 1),
              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('message.birthYear')), 1),
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setBirthYear,
                radius: '0.5rem',
                type: 'number',
                value: 
                _ctx.userRegistrationStatePresenter.birthYear.value == null
                  ? ''
                  : _ctx.userRegistrationStatePresenter.birthYear.value.toString()
              
              }, null, 8, ["onChange", "value"]),
              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('message.email')), 1),
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setMail,
                radius: '0.5rem',
                type: 'email',
                value: 
                _ctx.userRegistrationStatePresenter.mail.value == null ? '' : _ctx.userRegistrationStatePresenter.mail.value
              
              }, null, 8, ["onChange", "value"]),
              _hoisted_48,
              _createVNode(_component_SingleLineInputArea, {
                onChange: _ctx.userRegistrationStatePresenter.setUrl,
                radius: '0.5rem',
                value: _ctx.userRegistrationStatePresenter.url.value == null ? '' : _ctx.userRegistrationStatePresenter.url.value
              }, null, 8, ["onChange", "value"]),
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('message.yourURL')), 1),
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_IconTextButton, {
                  border_radius: 2,
                  class: "mx-1",
                  disabled: _ctx.authStatePresenter.isLoading.value,
                  font_weight: '700',
                  icon: 'person_add',
                  iconSize: 'text-xl',
                  padding_bottom: 4,
                  padding_left: 10,
                  padding_right: 10,
                  padding_top: 4,
                  text: _ctx.$t('message.createNewAccount'),
                  textSize: 'text-base',
                  onClick: _ctx.registerUser
                }, null, 8, ["disabled", "text", "onClick"])
              ]),
              _hoisted_51
            ])
          ], 2)
        ])
      ])
    ]),
    _: 1
  }))
}